<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'zipcodes.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="zipcodesGrid" v-bind:preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'ZipcodesGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        'region_id': {
          type: 'number',
          editable: false
        }
      },
      url: 'zipcodes',
      preload: [{
        api: 'regions/lst',
        field: 'region_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'region_id',
        title: 'Região',
        width: '180px',
        values: []
      },
      {
        field: 'zip_code',
        title: 'Código Postal',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('zipcodes.edit')) {
        var route = router.resolve({
          name: 'zipcodes.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('zipcodes.view')) {
        var route = router.resolve({
          name: 'zipcodes.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
